"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeFlexProps = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  align-content: ", ";\n  align-items: ", ";\n  display: ", ";\n  flex-wrap: ", ";\n  justify-content: ", ";\n"], ["\n  align-content: ", ";\n  align-items: ", ";\n  display: ", ";\n  flex-wrap: ", ";\n  justify-content: ", ";\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require("./propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var makeFlexProps = function makeFlexProps(_ref) {
  var alignContent = _ref.alignContent,
      alignItems = _ref.alignItems,
      display = _ref.display,
      flexWrap = _ref.flexWrap,
      justifyContent = _ref.justifyContent,
      rest = _objectWithoutProperties(_ref, ["alignContent", "alignItems", "display", "flexWrap", "justifyContent"]);

  return _react2.default.createElement("div", rest);
};

exports.makeFlexProps = makeFlexProps;
var Flex = (0, _styledComponents2.default)(makeFlexProps)(_templateObject, function (props) {
  return props.alignContent;
}, function (props) {
  return props.alignItems;
}, function (props) {
  return props.display;
}, function (props) {
  return props.flexWrap;
}, function (props) {
  return props.justifyContent;
});
Flex.defaultProps = _propTypes.flexDefaultProps;
Flex.propTypes = _propTypes.flexPropTypes;
exports.default = Flex;